import {openWindow, shareImageToNative, shareUrlToWechat} from '@/plugins/bridge'
import {Popup, Toast} from 'gotu-ui'
import {memo, useEffect, useRef, useState} from 'react'
import copy from 'copy-to-clipboard'
import {discoverCache, imageIsAuth, uploadImageToCdn} from '@/service/activity'
import useDomToImage from '@/hooks/useDomToImage'
import classNames from 'classnames'
import {useUaParam} from '@/pages/_app'
import {haboClickReport} from '@/plugins/habo'
import {CombineImage_Map, IMAGE_MAP} from '@/constants/activityCdn'
const styles = require('./style.module.less')

export interface SharePopupProps {
  visible: boolean;
  close: () => void;
  doShare?: () => void;
}
let topNumberMap:Record<string, string> = {
    1: '13356755753436349',
    8: '13356755753436352',
    6: '13356755753436351',
    3: '13356755753436350',
}

const test_topNumberMap:Record<string, string> = {
    1: '13094728179124347',
    8: '13094728179124350',
    6: '13094728179124349',
    3: '13094728179124348',
}
const shareSourceMap:Record<string, string> = {
    1: 'tj212528026182751232z',
    8: 'tj212539690864088064z',
    6: 'tj212539739504385024z',
    3: 'tj212539777313938432z',
}

const SharePopup = (props: SharePopupProps) => {
    const {
        visible,
        close,
        doShare,
    } = props
    const [loading, setLoading] = useState(false)
    const {
        p_client = 1,
        source,
        isApp,
        isTest,
        fromId = 23001,
    } = useUaParam()

    const copyUrl = () => {
        const url = getUrl()
        if (copy(url)) {
            Toast.show('复制成功')
        }
        else {
            Toast.show('复制失败')
        }
        doShare && doShare()
        close()
    }
    const preventTouchMove = (e: any) => {
        e?.preventDefault()
    }
    //跳转发现页
  const goPush = async () => {
        const content = `一起来拼蛋糕吧！超多礼品等你拿~[快来看看吧](${getUrl()})`
        const shareData = {
            // 分享标题
            title: '高途十周岁啦',
            // 分享内容
            content,
        }
        const params = {data: JSON.stringify(shareData)}
        const cache = await discoverCache(params)
        if (cache.success && cache.data) {
            const id = cache.data
            if (isTest) {
                topNumberMap = test_topNumberMap
            }
            openWindow(`${location.origin}/blog/publish?topicNumber=${topNumberMap[p_client]}&source=${source}&shareContentId=${id}&redirectTopicDetial=false`, 'hide', 'show')
        }
        doShare && doShare()
        close()
    }
    // 微信分享
    const goWx = async (type:'wechat' | 'wechatMoments') => {
        shareUrlToWechat({
            type,
            title: '高途十周年 | 十年成长路 前行有高途',
            content:
            '一起来拼蛋糕吧！超多礼品等你拿',
            img: CombineImage_Map.share_wx_icon,
            url: getUrl(),
        })
        doShare && doShare()
        close()
    }
    const getUrl = () => {
        const origin = window.location.origin
        const pathname = window.location.pathname
        return `${origin}${pathname}?source=${shareSourceMap[p_client]}&p_client=${p_client}&fromId=${fromId}`
    }

    let shareList = [
        {
            image: IMAGE_MAP.share_comunity,
            onClick: goPush,
            name: '发现页',
            isApp: true,
        },
        {
            image: IMAGE_MAP.share_wx,
            onClick: () => goWx('wechat'),
            name: '微信',
            isApp: true,
        },
        {
            image: IMAGE_MAP.share_wx_comment,
            onClick: () => goWx('wechatMoments'),
            name: '朋友圈',
            isApp: true,
        },
        {image: IMAGE_MAP.share_copy, onClick: copyUrl, name: '复制链接'},
    ]
    if (!isApp) {
        shareList = shareList.filter((item) => !item.isApp)
    }
    if (!visible) return null
    return (
        <div
            className={classNames(styles.imgShare, visible && styles.visible)}
        >
            <div
                className={styles.imgBg}
                onTouchMove={preventTouchMove}
                onClick={close}
            ></div>
            <div className={styles.imgContent}>
                <div className={styles.footerContainer}>
                    <div className={styles.imgFooter}>
                        {
                            shareList.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={styles.inviteItem}
                                        onClick={item.onClick}
                                    >
                                        <div>
                                            <img
                                                src={item.image}
                                            />
                                        </div>
                                        {item.name}
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div
                        className={styles.footerButton}
                        onClick={close}
                    >
                        取消
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(SharePopup)
